import { useState } from "react";

const useSelectPermission = (initialValue) => {
  const [checked, setChecked] = useState(initialValue);

  const handleChangeLisPermissionIds = (permissionIds) => {
    setChecked({
      ...checked,
      ...permissionIds,
    });
  };
  return { checked, setChecked, handleChangeLisPermissionIds };
};

export default useSelectPermission;
